import { useEffect, useRef } from "react";

import useAuth from "../hooks/useAuthContext";
import { init, identify } from "../services/analytics";

// Mounted inside the V2 provider tree, so V1 stores and the /customers portal never initialize PostHog.
const AnalyticsProvider = ({ children }) => {
  const { user } = useAuth();
  const identifiedRef = useRef(false);

  useEffect(() => {
    if (identifiedRef.current || !user?.domain) return;

    init(user.domain);
    identify(user.domain);
    identifiedRef.current = true;
  }, [user?.domain]);

  return <>{children}</>;
};

export default AnalyticsProvider;
